import i18n from '../i18n/fr';
import { toFloat, toLocaleNumber } from '../helpers/math_helper';

const t = i18n[window.locale];

const formatters = {
  systemLabel: function(label, style){
    return (style == 'raw')
      ? label.split('|')[0]
      : label.split('|')[1];
  },
  periodTotalCost: {
    plotOptions: function(data) {
      return parseInt(data.y) == 0
        ? ''
        : toLocaleNumber(parseInt(data.y)) + ' ' + t.charts.period_total_cost.tooltip.devise;
    },
    tooltip: function(data) {
      const systemsLabel = data.x.substring(0, data.x.indexOf("<br/>"));
      let tooltipInfos = ['<b>' + systemsLabel + '</b>'];
      let total = 0;

      data.points.forEach( (point, index) => {
        let amount = point.y;
        (index == 0)
          ? amount = (amount == 0) ? amount : '-' + amount
          : total += point.y;
        tooltipInfos.push(
          '<span style="font-size: 1.2em; color: ' + point.series.color + ';">\u25A0</span> ' +
          point.series.name +': <b>'+ toLocaleNumber(parseInt(amount)) +'</b> ' +
          t.charts.period_total_cost.tooltip.devise
        );
      });
      return (
        tooltipInfos.join('<br />') + '<br /><b>' + t.charts.period_total_cost.tooltip.total + ' : ' +
        toLocaleNumber(parseInt(total)) + ' ' + t.charts.period_total_cost.tooltip.devise + '</b>'
      );
    },
    yAxis: function(data, series) {
      return toLocaleNumber(parseInt(data.total - series.solarSavingDatas[data.x])) +
        ' ' + t.charts.period_total_cost.tooltip.devise;
    },
  },
  periodCostEvolution: {
    tooltip: function(data) {
      let s = ['<b>' + data.points[0].x + '</b>'];
      data.points.forEach( (point, index) => {
        s.push(
          '<span style="font-size: 1.2em; color: ' + point.series.color + ';">\u25CF </span>' +
          formatters.systemLabel(point.series.name, 'styled') + ' : ' +
          '<b>' + toLocaleNumber(parseInt(point.y)) + '</b> ' +
          t.charts.period_cost_evolution.tooltip.devise
        );
      });
      return s.join('<br/>');
    },
  },
  environmentalImpact: {
    legend: function(data, style) {
      const item = (style =='raw')
        ? t.charts.environmental_impact[data.name].title + ' '
        : '<b>' + t.charts.environmental_impact[data.name].title + '</b> ';
      return  item + '(' + t.charts.environmental_impact[data.name].tooltip.unit + ')'
    },
    plotOptions: function(data) {
      return toLocaleNumber(parseInt(data.y));
    },
    tooltip: function(data) {
      let s = ['<b>' + formatters.systemLabel(data.points[0].x, 'styled') + '</b>'];
      data.points.forEach( (point, index) => {
        s.push(
          '<span style="font-size: 1.2em; color: ' + point.series.color + ';">\u25CF</span> ' +
          t.charts.environmental_impact[point.series.name].title +' : ' +
          '<b>'+ toLocaleNumber(parseInt(point.y)) + '</b>' +
          '<span style="font-weight: normal;"> ' + t.charts.environmental_impact[point.series.name].tooltip.unit + '</span>'
        );
      });
      return s.join('<br/>');
    },
    yAxis: function(data) {
      return (data.value < 1000)
        ? data.value
        : toLocaleNumber(Math.round(data.value / 1000)) + 'k';
    },
  },
  energiesPriceVariations: {
    legend: function(data, energyPriceVariation, style) {
      const sign = (energyPriceVariation >= 0) ? '+' : '-';
      const variation = (style == 'raw')
        ? '(' + sign + toFloat(energyPriceVariation, 2) + '%/an)'
        : '<b>(' + sign + toFloat(energyPriceVariation, 2) + '%/an)</b>';
      return t.datas.energy_types[data.name] + ' ' + variation;
    },
    tooltip: function(data) {
      let s = ['<b>' + data.points[0].x + '</b>'];
      data.points.forEach( (point, index) => {
        s.push(
          '<span style="color: ' + point.series.color + ';">\u25CF</span> ' +
          t.datas.energy_types[point.series.name] + ' : ' +
          '<b>' + toFloat(point.y, 2) + '</b> ' + t.charts.energies_yearly_price_variations.tooltip.devise
        );
      });
      return s.join('<br/>');
    },
  },
};

export default formatters;



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/charts_formatter_helper.js